export default {
  title: "Inviter dans l'organisation",
  role: 'Rôle',
  roleHint: "Ce que les personnes invitées détiendront une fois l'invitation acceptée.",
  rolesUnavailable: "Les rôles n'ont pas pu être chargés.",
  send: 'Envoyer ({count})',
  sent: 'Invitations envoyées : {count}.',
  alreadyMembers: "Déjà membres de l'organisation :",
  failed: "Ces invitations n'ont pas pu être envoyées :",
  roleTooHigh: "Votre rôle ne permet pas d'accorder celui-ci. Choisissez un rôle qui ne dépasse pas le vôtre.",
  rateLimited: "Trop d'invitations pour le moment. Réessayez plus tard.",
  mailUnavailable: "Aucun e-mail ne peut être envoyé depuis cette plateforme pour l'instant. Réessayez plus tard.",
  accessTooHigh:
    "Votre rôle ne permet pas d'accorder ce rôle, ou l'accès à l'un de ces espaces. Choisissez un rôle qui ne dépasse pas le vôtre.",
  access: {
    customizeTitle: 'Donner accès à des espaces',
    searchPlaceholder: 'Rechercher un espace…',
    defaultRole: 'Rôle par défaut',
    noResults: 'Aucun espace ne correspond',
    private: 'Espace privé',
    public: 'Espace public',
    unavailable: "Les espaces n'ont pas pu être chargés.",
    workspaceGone: "L'un des espaces choisis n'existe plus. Rechargez la liste et réessayez.",
  },
  preview: {
    title: 'Ce à quoi ils auront accès',
    allWorkspaces: 'Tous les espaces',
    readOnly: 'Lecture',
    grantedTitle: 'Espaces que vous attribuez',
    publicTitle: 'Espaces publics, accessibles automatiquement',
    publicNote: 'En lecture seule, sans y être ajoutés.',
    noWorkspaces: "Membre de l'organisation uniquement — aucun accès à un espace.",
  },
  viewInvitations: 'Invitations en attente',
}
